import * as React     from 'react'
import { withRouter } from 'react-router'

import IconButton from '@material-ui/core/IconButton'
import BackIcon   from '@material-ui/icons/ArrowBack'

const Back = withRouter(
  ({ history: { length, goBack } }) => (
    <IconButton onClick={goBack}>
      <BackIcon />
    </IconButton>
  )
)

export default Back



// WEBPACK FOOTER //
// ./src/components/atoms/Back.tsx